import { FilterOptions } from '../components/FilterBar';
import { FilterInfo } from './types';

export class FilterOptionsUtils {

  static convertFilterInfoToFilterOptions = (filterInfo: FilterInfo): FilterOptions => {
    return {
      startDate: filterInfo.start_date,
      endDate: filterInfo.end_date,
      ages: filterInfo.ages,
      activityKeywords: filterInfo.activity_keywords,
      duration: filterInfo.duration as 'full-day' | 'half-day',
      minPrice: filterInfo.min_price,
      maxPrice: filterInfo.max_price,
      minRating: filterInfo.min_rating,
    };
  };
  
  static convertFilterOptionsToFilterInfo = (filterOptions: FilterOptions): FilterInfo => {
    return {
      activity_keywords: filterOptions.activityKeywords,
      ages: filterOptions.ages,
      start_date: filterOptions.startDate,
      end_date: filterOptions.endDate,
      duration: filterOptions.duration as 'full-day' | 'half-day',
      min_price: filterOptions.minPrice,
      max_price: filterOptions.maxPrice,
      min_rating: filterOptions.minRating,
    };
  };


  static filtersToSearchParams(filters: FilterOptions): URLSearchParams {
    const searchParams = new URLSearchParams();
    
    if (filters.activityKeywords && filters.activityKeywords.length > 0) {
      searchParams.set('activities', filters.activityKeywords.join(','));
    }
    
    if (filters.ages && filters.ages.length > 0) {
      searchParams.set('ages', filters.ages.join(','));
    }
    
    if (filters.startDate) {
      searchParams.set('startDate', filters.startDate);
    }
    if (filters.endDate) {
      searchParams.set('endDate', filters.endDate);
    }
    if (filters.duration) {
      searchParams.set('duration', filters.duration);
    }
    if (filters.minPrice) {
      searchParams.set('minPrice', filters.minPrice.toString());
    }
    if (filters.maxPrice) {
      searchParams.set('maxPrice', filters.maxPrice.toString());
    }
    if (filters.minRating) {
      searchParams.set('minRating', filters.minRating.toString());
    }
    
    return searchParams;
  }


  static searchParamsToFilters(searchParams: URLSearchParams): FilterOptions {
    const filters: FilterOptions = {};
    
    const activities = searchParams.get('activities');
    if (activities) {
      filters.activityKeywords = activities.split(',').map(a => a.trim());
    }
    
    const ages = searchParams.get('ages');
    if (ages) {
      const ageNumbers = ages.split(',').map(a => parseInt(a.trim())).filter(a => !isNaN(a));
      filters.ages = ageNumbers;
    }
    
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    if (startDate) {
      filters.startDate = startDate;
    }
    if (endDate) {
      filters.endDate = endDate;
    }
    const duration = searchParams.get('duration');
    if (duration) {
      filters.duration = duration as 'full-day' | 'half-day';
    }
    const minPrice = searchParams.get('minPrice');
    if (minPrice) {
      filters.minPrice = parseInt(minPrice);
    }
    const maxPrice = searchParams.get('maxPrice');
    if (maxPrice) {
      filters.maxPrice = parseInt(maxPrice);
    }
    const minRating = searchParams.get('minRating');
    if (minRating) {
      filters.minRating = parseFloat(minRating);
    }
    
    return filters;
  }

  // static hasFilterParameters(searchParams: URLSearchParams): boolean {
  //   const filterKeys = [
  //     'activities', 'ages', 'startDate', 'endDate', 
  //     'location', 'time', 'capacity', 'organizer', 'min_price', 'max_price'
  //   ];
    
  //   return filterKeys.some(key => searchParams.has(key));
  // }
}
